/**
 * function sets the hovered flag on inidicators.
 * The flag is used to highlight the hovered row.
 * @param {boolean} isHovered
 */
export default function (isHovered) {
  this.indicator.indicatorHovered = isHovered;
}



// WEBPACK FOOTER //
// ./src/helpers/hoverHelpers.js